// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Roboto+Slab:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Roboto+Serif:ital,opsz,wght@0,8..144,100..900;1,8..144,100..900&family=Roboto+Slab:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&family=Inter:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&family=Inter:wght@100..900&family=Roboto+Slab:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&family=Inter:wght@100..900&family=Roboto+Slab:wght@100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Galada&family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Galada&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
@media (min-width: 1920px){

  .container{
    max-width: 1920px;
  }
}
@media (min-width: 2320px){

  .container{
    max-width: 2320px;
  }
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.bottom-0{
  bottom: 0px;
}
.bottom-6{
  bottom: 1.5rem;
}
.bottom-\\[-10px\\]{
  bottom: -10px;
}
.bottom-\\[100px\\]{
  bottom: 100px;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-\\[-2px\\]{
  right: -2px;
}
.right-\\[18px\\]{
  right: 18px;
}
.top-0{
  top: 0px;
}
.top-\\[-16px\\]{
  top: -16px;
}
.top-\\[-2px\\]{
  top: -2px;
}
.top-\\[15px\\]{
  top: 15px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[70px\\]{
  top: 70px;
}
.-z-10{
  z-index: -10;
}
.z-10{
  z-index: 10;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[1000\\]{
  z-index: 1000;
}
.z-\\[104\\]{
  z-index: 104;
}
.z-\\[110\\]{
  z-index: 110;
}
.m-1{
  margin: 0.25rem;
}
.m-2{
  margin: 0.5rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0{
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-\\[12px\\]{
  margin-top: 12px;
  margin-bottom: 12px;
}
.-ml-px{
  margin-left: -1px;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[10px\\]{
  margin-bottom: 10px;
}
.mb-\\[12px\\]{
  margin-bottom: 12px;
}
.mb-\\[24px\\]{
  margin-bottom: 24px;
}
.mb-\\[30px\\]{
  margin-bottom: 30px;
}
.mb-\\[36px\\]{
  margin-bottom: 36px;
}
.mb-\\[40px\\]{
  margin-bottom: 40px;
}
.mb-\\[48px\\]{
  margin-bottom: 48px;
}
.mb-\\[50px\\]{
  margin-bottom: 50px;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-\\[24px\\]{
  margin-left: 24px;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-\\[10px\\]{
  margin-right: 10px;
}
.mr-\\[18px\\]{
  margin-right: 18px;
}
.mr-\\[3px\\]{
  margin-right: 3px;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[24px\\]{
  margin-top: 24px;
}
.box-border{
  box-sizing: border-box;
}
.box-content{
  box-sizing: content-box;
}
.block{
  display: block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-4{
  height: 1rem;
}
.h-\\[100\\%\\]{
  height: 100%;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[144px\\]{
  height: 144px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[216px\\]{
  height: 216px;
}
.h-\\[calc\\(100vh-224px\\)\\]{
  height: calc(100vh - 224px);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.max-h-8{
  max-height: 2rem;
}
.max-h-\\[500px\\]{
  max-height: 500px;
}
.min-h-\\[1100px\\]{
  min-height: 1100px;
}
.min-h-\\[1vh\\]{
  min-height: 1vh;
}
.min-h-\\[32px\\]{
  min-height: 32px;
}
.min-h-\\[48px\\]{
  min-height: 48px;
}
.min-h-\\[67px\\]{
  min-height: 67px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-11{
  width: 2.75rem;
}
.w-4{
  width: 1rem;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[129px\\]{
  width: 129px;
}
.w-\\[220px\\]{
  width: 220px;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[50\\%\\]{
  width: 50%;
}
.w-\\[60\\%\\]{
  width: 60%;
}
.w-\\[67px\\]{
  width: 67px;
}
.w-\\[85px\\]{
  width: 85px;
}
.w-\\[86px\\]{
  width: 86px;
}
.w-\\[calc\\(100\\%-48px\\)\\]{
  width: calc(100% - 48px);
}
.w-\\[calc\\(50\\%-0\\.3rem\\)\\]{
  width: calc(50% - 0.3rem);
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[85px\\]{
  min-width: 85px;
}
.max-w-\\[1200px\\]{
  max-width: 1200px;
}
.max-w-\\[1620px\\]{
  max-width: 1620px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[320px\\]{
  max-width: 320px;
}
.max-w-\\[800px\\]{
  max-width: 800px;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-\\[0_0_45\\%\\]{
  flex: 0 0 45%;
}
.flex-\\[0_0_55\\%\\]{
  flex: 0 0 55%;
}
.flex-\\[2\\]{
  flex: 2;
}
.flex-\\[3\\]{
  flex: 3;
}
.flex-shrink-\\[2\\]{
  flex-shrink: 2;
}
.shrink-0{
  flex-shrink: 0;
}
.shrink-\\[1\\]{
  flex-shrink: 1;
}
.shrink-\\[3\\]{
  flex-shrink: 3;
}
.flex-grow-\\[2\\]{
  flex-grow: 2;
}
.grow-\\[1\\]{
  flex-grow: 1;
}
.grow-\\[3\\]{
  flex-grow: 3;
}
.basis-0{
  flex-basis: 0px;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes slideUpFadeIn{

  0%{
    opacity: 0;
    transform: translateY(20px) translateX(-50%);
  }

  100%{
    opacity: 1;
    transform: translateY(0) translateX(-50%);
  }
}
.animate-slideUpFadeIn{
  animation: slideUpFadeIn 0.4s ease-out;
}
.cursor-default{
  cursor: default;
}
.cursor-move{
  cursor: move;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.select-none{
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.resize{
  resize: both;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[10px\\]{
  gap: 10px;
}
.gap-\\[12px\\]{
  gap: 12px;
}
.gap-\\[18px\\]{
  gap: 18px;
}
.gap-\\[20px\\]{
  gap: 20px;
}
.gap-\\[24px\\]{
  gap: 24px;
}
.gap-\\[36px\\]{
  gap: 36px;
}
.gap-\\[48px\\]{
  gap: 48px;
}
.gap-\\[4px\\]{
  gap: 4px;
}
.gap-\\[8px\\]{
  gap: 8px;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-y-auto{
  overflow-y: auto;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-\\[11px\\]{
  border-radius: 11px;
}
.rounded-\\[12px\\]{
  border-radius: 12px;
}
.rounded-\\[16px\\]{
  border-radius: 16px;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-\\[5px\\]{
  border-radius: 5px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-t-\\[16px\\]{
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-b-0{
  border-bottom-width: 0px;
}
.border-l{
  border-left-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-t-0{
  border-top-width: 0px;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[\\#00000026\\]{
  border-color: #00000026;
}
.border-\\[\\#125590\\]{
  --tw-border-opacity: 1;
  border-color: rgb(18 85 144 / var(--tw-border-opacity, 1));
}
.border-\\[\\#B7EBFF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(183 235 255 / var(--tw-border-opacity, 1));
}
.border-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\]{
  border-color: rgba(0,0,0,0.15);
}
.bg-\\[\\#00000008\\]{
  background-color: #00000008;
}
.bg-\\[\\#000C17\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 12 23 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1890ff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 144 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3498db\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(52 152 219 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8AD1F1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(138 209 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D9D9D980\\]\\/50{
  background-color: rgb(217 217 217 / 0.5);
}
.bg-\\[\\#EEFBFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(238 251 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F5F5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8F8F8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\]{
  background-color: rgba(0,0,0,0.06);
}
.bg-\\[white\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-70{
  --tw-bg-opacity: 0.7;
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.from-gray-100{
  --tw-gradient-from: #f3f4f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 244 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-gray-200{
  --tw-gradient-to: #e5e7eb var(--tw-gradient-to-position);
}
.object-contain{
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover{
  -o-object-fit: cover;
     object-fit: cover;
}
.object-center{
  -o-object-position: center;
     object-position: center;
}
.object-top{
  -o-object-position: top;
     object-position: top;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[24px\\]{
  padding: 24px;
}
.p-\\[4px\\]{
  padding: 4px;
}
.p-\\[8px\\]{
  padding: 8px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-\\[12px\\]{
  padding-left: 12px;
  padding-right: 12px;
}
.px-\\[16px\\]{
  padding-left: 16px;
  padding-right: 16px;
}
.px-\\[178px\\]{
  padding-left: 178px;
  padding-right: 178px;
}
.px-\\[18px\\]{
  padding-left: 18px;
  padding-right: 18px;
}
.px-\\[40px\\]{
  padding-left: 40px;
  padding-right: 40px;
}
.px-\\[8px\\]{
  padding-left: 8px;
  padding-right: 8px;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-\\[12px\\]{
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[1px\\]{
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[24px\\]{
  padding-top: 24px;
  padding-bottom: 24px;
}
.py-\\[32px\\]{
  padding-top: 32px;
  padding-bottom: 32px;
}
.py-\\[48px\\]{
  padding-top: 48px;
  padding-bottom: 48px;
}
.py-\\[4px\\]{
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[68px\\]{
  padding-top: 68px;
  padding-bottom: 68px;
}
.py-\\[8px\\]{
  padding-top: 8px;
  padding-bottom: 8px;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-\\[26px\\]{
  padding-bottom: 26px;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-\\[32px\\]{
  padding-top: 32px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.align-middle{
  vertical-align: middle;
}
.font-roboto-sans{
  font-family: Roboto, sans-serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.lowercase{
  text-transform: lowercase;
}
.italic{
  font-style: italic;
}
.leading-\\[100\\%\\]{
  line-height: 100%;
}
.leading-\\[22px\\]{
  line-height: 22px;
}
.leading-relaxed{
  line-height: 1.625;
}
.text-\\[\\#00000040\\]{
  color: #00000040;
}
.text-\\[\\#00000073\\]{
  color: #00000073;
}
.text-\\[\\#000000a6\\]{
  color: #000000a6;
}
.text-\\[\\#000000e0\\]{
  color: #000000e0;
}
.text-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.65\\)\\]{
  color: rgba(0,0,0,0.65);
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.opacity-100{
  opacity: 1;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-85{
  opacity: 0.85;
}
.shadow-\\[0px_4px_8px_0px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\]{
  --tw-shadow: 0px 4px 8px 0px rgba(0,0,0,0.05);
  --tw-shadow-colored: 0px 4px 8px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-blue-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm{
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-500{
  transition-duration: 500ms;
}

/**
* Center vertially and horizontally
*/
.flex-center-v-h{
  display: flex;
  align-items: center;
  justify-content: center;
}

body {
  padding: 0;
  margin: 0;
  background:
    radial-gradient(158.02% 158.02% at 100% 100%, rgba(52, 152, 219, 0.1) 0%, rgba(52, 152, 219, 0) 100%),
    radial-gradient(158.02% 158.02% at 0% 100%, rgba(219, 55, 53, 0.06) 0%, rgba(219, 55, 53, 0) 100%),
    #FFFFFF;
  background-repeat: no-repeat;
  background-size: cover;
}

/** ANTD STYLES */

.ant-menu-horizontal {
  border-bottom: none !important;
}

.ant-steps-horizontal .ant-steps-item-active {
  flex: 4.5;
}

.ant-steps>.ant-steps-item>.ant-steps-item-container>.ant-steps-item-icon {
  margin-inline-end: 0px;
}

.ant-steps>.ant-steps-item-active>.ant-steps-item-container>.ant-steps-item-content {
  margin-left: 8px;
}

.ant-steps>.ant-steps-item-active>.ant-steps-item-container>.ant-steps-item-icon>.ant-steps-icon {
  color: white !important;
}

.ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title::after {
  background-color: rgba(5, 5, 5, 0.06) !important;
}

.ant-steps-item-active .ant-steps-icon {
  color: black !important;
}

.ant-tooltip {
  line-height: 1.5 !important;
}

.design-color-picker .ant-color-picker-trigger {
  width: 100% !important;
  min-width: 120px !important;
  height: 120px !important;
}

.design-color-picker .ant-color-picker-color-block {
  width: 100% !important;
  height: 100% !important;
}

.abjust-colors.ant-color-picker-trigger {
  width: 100% !important;
  min-width: 120px !important;
  height: 120px !important;
}

.abjust-colors:not(.ant-popover) .ant-color-picker-color-block {
  width: 100% !important;
  height: 100% !important;
}

.rct-tree-root {
  width: calc(50%);
  margin-right: 10px;
}

.rct-tree-item-button:hover {
  background: none !important;
}

.rct-tree-item-li {
  box-sizing: content-box !important;
  background-color: rgb(245 245 244 / var(--tw-bg-opacity));
}

.rct-tree-item-button {
  margin: 7px 0px !important;
  cursor: move !important;
}

button.ant-btn-primary:hover {
  background-color: #5db5e8 !important;
  color: #fff !important;
}


/* ANIMATIONS */

.slide-top {
  animation: slide-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) normal;
}

/* ----------------------------------------------
 * Generated by Animista on 2023-10-20 14:32:53
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation slide-top
 * ----------------------------------------
 */

@keyframes slide-top {
  0% {
    opacity: 0;
    transform: translateY(-30px);
  }

  100% {
    opacity: 1;
    transform: none;
  }
}

.keywords-tags>.ant-select-selector {
  border: none !important;
}

.page-tree-menu>li.ant-menu-item {
  padding: 0px !important;
}

.page-tree-menu {
  border-inline-end: none !important;
}

/**
* Tree styles
*/

.nodeWrapper {
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  z-index: 3;
}

.nodeWrapper .expandIconWrapper {
  align-items: center;
  font-size: 0;
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  width: 24px;
  transform: rotate(0deg);
}

.nodeWrapper .expandIconWrapper.isOpen {
  transform: rotate(180deg);
}

.nodeWrapper .expandIconWrapper.isOpen svg path {
  fill: #4f5272;
}

.nodeWrapper .labelGridItem {
  padding-inline-start: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pipeY {
  position: absolute;
  border-left: 2px solid #e7e7e7;
  left: -7px;
  /*top: 5px;*/
  top: -13px;
}

.pipeX {
  position: absolute;
  left: -7px;
  top: 15px;
  height: 2px;
  background-color: #e7e7e7;
  z-index: -1;
}

.wrapper {
  font-family: sans-serif;
}

.treeRoot {
  list-style-type: none;
  padding-inline-start: 0px;
  padding: 0px 0px;
  position: relative;
}

.treeRoot ul {
  list-style-type: none;
  padding-inline-start: 0px;
  position: relative;
  padding-bottom: 5px;
}

.treeRoot>li:after {
  display: none;
}

.wrapper .draggingSource {
  opacity: 0.3;
}

.wrapper .placeholder {
  position: relative;
}

.wrapper>ul>li>.nodeWrapper>div.pipeY {
  display: none;
}

[data-tree] li[role='listitem'] {
  margin: 6px 0px;
}

[data-tree]>ul[role='list']>li>div>[data-pipe-y] {
  top: 5px !important;
  display: none !important;
}

.wrapper li:has(> .dropTarget) {
  outline: 3px solid #e8f0fe;
  border-radius: 4px;
}

.ant-modal-content {
  border-radius: 16px !important;
  padding: 24px !important;
}

.phone{
  transition: all 0.3s ease;
}

.phone:hover{
  border-bottom: transparent !important;
}

input,
select,
textarea,
.ant-input,
.ant-select-selector,
.ant-picker,
.ant-input-affix-wrapper {
  font-size: 16px !important;
  line-height: 24px !important;
  border-radius: 16px !important;
  height: auto !important;
  padding: 8px 16px !important;
}

.ant-select-selection-search-input {
  padding-left: 8px !important;
  padding: 7px 8px !important;
  height: 100% !important;
}

.ant-select-selection-search {
  /* width: 100% !important; */
}

.ant-select-selection-search-input {
  width: 100% !important;
  padding-left: 4px !important;
}

.ant-select-selection-placeholder {
  padding-left: 8px !important;
}

input::-moz-placeholder, textarea::-moz-placeholder, .ant-input::-moz-placeholder {
  color: #00000040 !important;
  opacity: 1 !important;
}

input::placeholder,
textarea::placeholder,
.ant-input::placeholder,
.ant-select-selection-placeholder {
  color: #00000040 !important;
  opacity: 1 !important;
}

button:not(.slider-button) {
  height: auto;
}

/* .ant-btn-icon-only{
  padding: 10px 20px !important;
} */

button.disabled span {
  color: rgba(0, 0, 0, 0.25) !important;
}

button.disabled svg {
  opacity: 0.4;
  background: #0000000A;
}

.ant-btn {
  white-space: normal !important;
}

.custom-checkbox.ant-btn {
  padding-top: 12px !important;
  padding-right: 24px !important;
  padding-bottom: 12px !important;
  padding-left: 20px !important;
}

.search-images-input input {
  border-radius: none !important;
  border-end-end-radius: 0 !important;
  border-start-end-radius: 0 !important;

  border-start-start-radius: 0 !important;
  border-end-start-radius: 0 !important;
  height: 40px !important;

}

.search-images-input button {
  height: 40px !important;
}

.search-activity-input {
  height: auto !important;
}

.ant-select-selection-placeholder {
  text-align: left !important;
}

.ant-select-selector {
  padding: 5px !important;
}

.ant-select-arrow {
  margin-top: -3px !important;
}

.ant-input-outlined .ant-input {
  padding: 0 !important;
  padding-left: 10px !important;
}

.company-data-form label:not(.ant-radio-wrapper) {
  font-weight: 700 !important;
}

.company-data-form label {
  text-align: left !important;
}

.company-data-social-form .ant-select-selector {
  height: 100% !important;
}

.company-data-social-form .ant-select-arrow {
  margin-top: -7px !important;
}

.company-data-form label:before {
  display: none !important;
}

.company-data-form .ant-select-selector {
  padding: 4px !important;
}

.ant-input-prefix {
  opacity: 0.45;
}

.ant-select-selection-item {
  padding-left: 12px !important;
  text-align: left !important;
}

.ant-color-picker-input-container .ant-select-selection-item {
  font-size: 12px !important;
}

.ant-color-picker .ant-input,
.ant-color-picker input {
  padding: 4px 11px !important;
  font-size: 12px !important;
}

.ant-color-picker-input-container {
  align-items: center !important;
}

.ant-color-picker-hex-input .ant-input-sm {
  padding: 0 !important;

}

.ant-color-picker-input-container .ant-input-number-input {
  padding: 4px 7px !important;
}

.ant-input-number-input {
  padding: 4px !important;
}

:where(.css-dev-only-do-not-override-1c9uand).ant-color-picker .ant-color-picker-inner .ant-color-picker-input-container .ant-color-picker-format-select.ant-select {
  height: 100% !important;
}

.ant-color-picker-input-container .ant-input-affix-wrapper {
  padding: 4px !important;
  border-radius: 5px !important;
}

.ant-form-item-explain-error {
  text-align: left !important;
}

.social-media-item .ant-select-selection-item {
  font-size: 16px !important;
}

.social-media-item .ant-select {
  height: 40px !important;
}

.pulse {
  animation: pulse-animation 2s infinite;
}

@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0 rgba(52, 152, 219, 0.8);
  }

  100% {
    box-shadow: 0 0 0 20px rgba(52, 152, 219, 0);
  }
}

.mt-4 .ant-upload {
  width: 100%;
}

.sitemap-keywords>.ant-select-selector {
  border: none !important;
  background-color: transparent !important;
  border-radius: 12px !important;
}

.sitemap-keywords .ant-select {
  border-radius: 12px !important;
}

.sitemap-keywords .ant-select-selector {
  
}


#customKeywords {
  width: auto !important;
  -webkit-appearance: none !important;
     -moz-appearance: none !important;
          appearance: none !important;
  border-radius: none !important;
  min-width: auto !important;
}

.preview-editor-shell {
  --preview-header-h: 48px;
  --preview-mobile-nav-h: 67px;
  --preview-footer-h: 72px;
  --preview-cta-h: 72px;
  --preview-mobile-chrome-top: calc(var(--preview-header-h) + var(--preview-mobile-nav-h));
  --preview-mobile-chrome-bottom: calc(var(--preview-footer-h) + var(--preview-cta-h) + 8px);
  --preview-mobile-cta-bottom: var(--preview-footer-h);
  --preview-sitemap-drawer-top: 72px;
  --preview-sitemap-drawer-height: calc(100vh - 162px);
}

@media (min-width: 768px) {
  .preview-editor-shell {
    --preview-mobile-chrome-top: 0px;
    --preview-mobile-chrome-bottom: 0px;
  }
}

.preview-editor-shell .preview-iframe {
  height: calc(100vh - var(--preview-mobile-chrome-top) - var(--preview-mobile-chrome-bottom));
}

@media (min-width: 768px) {
  .preview-editor-shell .preview-iframe {
    height: calc(100vh - 300px);
  }
}

.reset-wizard-preview {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 999;
  margin-top: 0;
}

@media (max-width: 767px) {
  .preview-editor-active,
  .preview-editor-shell {
    --preview-reset-form-bottom: calc(
      var(--preview-mobile-cta-bottom) + var(--preview-cta-h) + 8px
    );
  }

  .reset-wizard-preview {
    bottom: var(--preview-reset-form-bottom);
    display: flex;
    justify-content: flex-start;
    padding: 4px 12px;
    background: #fff;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }
}

@media (min-width: 768px) {
  .reset-wizard-preview {
    bottom: 242px;
    display: flex;
    justify-content: center;
  }
}
@media (max-width: 768px) {
  .reset-wizard-preview {
    bottom: 160px;
    display: flex;
    justify-content: center;
    button {
      padding: 4px 0 !important;
    }
  }
}
@media (max-width: 639px) {
  .reset-wizard-preview {
    bottom: 150px;
    display: flex;
    justify-content: center;
    button {
      padding: 4px 0 !important;
    }
  }
}
/* @media (max-width: 639px) {
  .reset-wizard-preview {
    bottom: 188px;
    display: flex;
    justify-content: center;
  }
} */

@media (max-width: 767px) {
  .preview-editor-shell {
    --preview-header-h: 0px;
    --preview-mobile-chrome-top: var(--preview-mobile-nav-h);
    --preview-sitemap-drawer-top: var(--preview-mobile-chrome-top);
    --preview-sitemap-drawer-height: calc(100vh - var(--preview-mobile-chrome-top) - var(--preview-footer-h));
  }

  .preview-editor-active {
    --preview-footer-h: 72px;
    --preview-cta-h: 72px;
    --preview-mobile-cta-bottom: var(--preview-footer-h);
  }

  .preview-editor-shell .preview-drawer-panel {
    position: fixed;
    left: 0;
    right: 0;
    top: var(--preview-mobile-chrome-top);
    bottom: var(--preview-mobile-chrome-bottom);
    z-index: 105;
    width: 100% !important;
    height: auto;
    overflow-y: auto;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    padding-bottom: 100px;
  }
}

@media (min-width: 768px) {
  .preview-editor-shell .preview-drawer-panel {
    display: flex;
    flex-direction: column;
    width: 350px;
    height: 100%;
    flex-shrink: 0;
    overflow-y: auto;
    background: #fff;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.04);
    z-index: 9;
    padding-bottom: 100px;
  }
}

.preview-no-scroll {
  overflow-y: hidden !important;
}

.whitespace-nowrap{
  white-space: nowrap !important;
}

.last\\:mb-0:last-child{
  margin-bottom: 0px;
}

.hover\\:bg-blue-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

@media not all and (min-width: 768px){

  .max-md\\:bottom-\\[72px\\]{
    bottom: 72px;
  }

  .max-md\\:left-3{
    left: 0.75rem;
  }

  .max-md\\:right-3{
    right: 0.75rem;
  }

  .max-md\\:h-\\[calc\\(100vh-var\\(--preview-mobile-chrome-bottom\\)\\)\\]{
    height: calc(100vh - var(--preview-mobile-chrome-bottom));
  }

  .max-md\\:min-h-0{
    min-height: 0px;
  }

  .max-md\\:w-auto{
    width: auto;
  }

  .max-md\\:max-w-none{
    max-width: none;
  }

  .max-md\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .max-md\\:p-4{
    padding: 1rem;
  }

  .max-md\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .max-md\\:pt-\\[calc\\(var\\(--preview-mobile-chrome-top\\)-20px\\)\\]{
    padding-top: calc(var(--preview-mobile-chrome-top) - 20px);
  }

  .max-md\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .max-md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .max-md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .max-md\\:leading-tight{
    line-height: 1.25;
  }
}

@media not all and (min-width: 640px){

  .max-sm\\:bottom-\\[62px\\]{
    bottom: 62px;
  }
}

@media (min-width: 640px){

  .sm\\:block{
    display: block;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:h-\\[40px\\]{
    height: 40px;
  }

  .sm\\:w-\\[296px\\]{
    width: 296px;
  }

  .sm\\:w-\\[33\\.33\\%\\]{
    width: 33.33%;
  }

  .sm\\:w-\\[380px\\]{
    width: 380px;
  }

  .sm\\:w-\\[618px\\]{
    width: 618px;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-start{
    justify-content: flex-start;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-center{
    justify-content: center;
  }

  .sm\\:gap-0{
    gap: 0px;
  }

  .sm\\:gap-8{
    gap: 2rem;
  }

  .sm\\:text-center{
    text-align: center;
  }
}

@media (min-width: 768px){

  .md\\:bottom-\\[118px\\]{
    bottom: 118px;
  }

  .md\\:left-\\[50\\%\\]{
    left: 50%;
  }

  .md\\:mb-8{
    margin-bottom: 2rem;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:block{
    display: block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-\\[200px\\]{
    height: 200px;
  }

  .md\\:w-\\[16\\.66\\%\\]{
    width: 16.66%;
  }

  .md\\:w-\\[423px\\]{
    width: 423px;
  }

  .md\\:w-\\[calc\\(100\\%-88px\\)\\]{
    width: calc(100% - 88px);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-\\[calc\\(100\\%-88px\\)\\]{
    max-width: calc(100% - 88px);
  }

  .md\\:translate-x-\\[-50\\%\\]{
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:gap-1{
    gap: 0.25rem;
  }

  .md\\:gap-4{
    gap: 1rem;
  }

  .md\\:gap-\\[18px\\]{
    gap: 18px;
  }

  .md\\:gap-\\[8px\\]{
    gap: 8px;
  }

  .md\\:overflow-hidden{
    overflow: hidden;
  }

  .md\\:rounded-full{
    border-radius: 9999px;
  }

  .md\\:p-4{
    padding: 1rem;
  }

  .md\\:p-\\[24px\\]{
    padding: 24px;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-\\[105px\\]{
    padding-left: 105px;
    padding-right: 105px;
  }

  .md\\:px-\\[38px\\]{
    padding-left: 38px;
    padding-right: 38px;
  }

  .md\\:py-\\[22px\\]{
    padding-top: 22px;
    padding-bottom: 22px;
  }

  .md\\:py-\\[60px\\]{
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .md\\:py-\\[68px\\]{
    padding-top: 68px;
    padding-bottom: 68px;
  }

  .md\\:pt-\\[60px\\]{
    padding-top: 60px;
  }

  .md\\:pt-\\[63px\\]{
    padding-top: 63px;
  }

  .md\\:text-center{
    text-align: center;
  }

  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

@media (min-width: 1024px){

  .lg\\:bottom-\\[78px\\]{
    bottom: 78px;
  }

  .lg\\:w-\\[100\\%\\]{
    width: 100%;
  }

  .lg\\:w-\\[calc\\(50\\%-1rem\\)\\]{
    width: calc(50% - 1rem);
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:justify-end{
    justify-content: flex-end;
  }
}

@media (min-width: 1280px){

  .xl\\:px-\\[180px\\]{
    padding-left: 180px;
    padding-right: 180px;
  }
}

@media (min-width: 1536px){

  .\\32xl\\:flex{
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./frontend/index.css"],"names":[],"mappings":"AAgBA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA,0BAAmB;KAAnB;AAAmB;AAAnB;EAAA,uBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;CAEC;AAEC;EAAA,aAAuC;EAAvC,mBAAuC;EAAvC;AAAuC;;AAGzC;EACE,UAAU;EACV,SAAS;EACT;;;WAGS;EACT,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,iBAAiB;;AAEjB;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,yDAAyD;AAC3D;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;;AAGA,eAAe;;AAEf;EAEE,qEAAqE;AACvE;;AAEA;;;;;mDAKmD;;AAEnD;;;;EAIE;;AAeF;EACE;IACE,UAAU;IAEV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IAEV,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;CAEC;;AAED;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU;EACV,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;;;;;EAOE,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EAIE,2BAA2B;EAC3B,qBAAqB;AACvB;;AANA;;;;EAIE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,qCAAqC;;EAErC,uCAAuC;EACvC,qCAAqC;EACrC,uBAAuB;;AAEzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;;AAEvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;AAEA;;;AAGA;EACE,sBAAsB;EACtB,mCAA2B;KAA3B,gCAA2B;UAA3B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,qBAAqB;EACrB,wFAAwF;EACxF,0FAA0F;EAC1F,oDAAoD;EACpD,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;EACE;IACE,gCAAgC;IAChC,mCAAmC;EACrC;AACF;;AAEA;EACE,4FAA4F;AAC9F;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;;IAEE;;KAEC;EACH;;EAEA;IACE,wCAAwC;IACxC,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,aAAa;IACb,aAAa;IACb,uBAAuB;EACzB;AACF;AACA;EACE;IACE,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB;MACE,yBAAyB;IAC3B;EACF;AACF;AACA;EACE;IACE,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB;MACE,yBAAyB;IAC3B;EACF;AACF;AACA;;;;;;GAMG;;AAEH;EACE;IACE,uBAAuB;IACvB,wDAAwD;IACxD,8DAA8D;IAC9D,yGAAyG;EAC3G;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,oDAAoD;EACtD;;EAEA;IACE,eAAe;IACf,OAAO;IACP,QAAQ;IACR,qCAAqC;IACrC,2CAA2C;IAC3C,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAppBA;EAAA;AAopBC;;AAppBD;EAAA,kBAopBC;EAppBD;AAopBC;;AAppBD;EAAA,kBAopBC;EAppBD;AAopBC;;AAppBD;EAAA,8BAopBC;EAppBD;AAopBC;;AAppBD;;EAAA;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA,qBAopBC;IAppBD;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA,qBAopBC;IAppBD;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA,mBAopBC;IAppBD;EAopBC;;EAppBD;IAAA,mBAopBC;IAppBD;EAopBC;;EAppBD;IAAA;EAopBC;AAAA;;AAppBD;;EAAA;IAAA;EAopBC;AAAA;;AAppBD;;EAAA;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;AAAA;;AAppBD;;EAAA;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA,sBAopBC;IAppBD;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA,oBAopBC;IAppBD;EAopBC;;EAppBD;IAAA,mBAopBC;IAppBD;EAopBC;;EAppBD;IAAA,kBAopBC;IAppBD;EAopBC;;EAppBD;IAAA,iBAopBC;IAppBD;EAopBC;;EAppBD;IAAA,iBAopBC;IAppBD;EAopBC;;EAppBD;IAAA,iBAopBC;IAppBD;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA,iBAopBC;IAppBD;EAopBC;;EAppBD;IAAA,eAopBC;IAppBD;EAopBC;AAAA;;AAppBD;;EAAA;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;;EAppBD;IAAA;EAopBC;AAAA;;AAppBD;;EAAA;IAAA,mBAopBC;IAppBD;EAopBC;AAAA;;AAppBD;;EAAA;IAAA;EAopBC;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;600;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Roboto+Slab:wght@100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Roboto+Serif:ital,opsz,wght@0,8..144,100..900;1,8..144,100..900&family=Roboto+Slab:wght@100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&display=swap');\n\n@import url('https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&family=Inter:wght@100..900&display=swap');\n\n@import url('https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&family=Inter:wght@100..900&family=Roboto+Slab:wght@100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&family=Inter:wght@100..900&family=Roboto+Slab:wght@100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n\n@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap');\n\n@import url('https://fonts.googleapis.com/css2?family=Galada&family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Galada&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/**\n* Center vertially and horizontally\n*/\n.flex-center-v-h {\n  @apply flex items-center justify-center;\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n  background:\n    radial-gradient(158.02% 158.02% at 100% 100%, rgba(52, 152, 219, 0.1) 0%, rgba(52, 152, 219, 0) 100%),\n    radial-gradient(158.02% 158.02% at 0% 100%, rgba(219, 55, 53, 0.06) 0%, rgba(219, 55, 53, 0) 100%),\n    #FFFFFF;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n/** ANTD STYLES */\n\n.ant-menu-horizontal {\n  border-bottom: none !important;\n}\n\n.ant-steps-horizontal .ant-steps-item-active {\n  flex: 4.5;\n}\n\n.ant-steps>.ant-steps-item>.ant-steps-item-container>.ant-steps-item-icon {\n  margin-inline-end: 0px;\n}\n\n.ant-steps>.ant-steps-item-active>.ant-steps-item-container>.ant-steps-item-content {\n  margin-left: 8px;\n}\n\n.ant-steps>.ant-steps-item-active>.ant-steps-item-container>.ant-steps-item-icon>.ant-steps-icon {\n  color: white !important;\n}\n\n.ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title::after {\n  background-color: rgba(5, 5, 5, 0.06) !important;\n}\n\n.ant-steps-item-active .ant-steps-icon {\n  color: black !important;\n}\n\n.ant-tooltip {\n  line-height: 1.5 !important;\n}\n\n.design-color-picker .ant-color-picker-trigger {\n  width: 100% !important;\n  min-width: 120px !important;\n  height: 120px !important;\n}\n\n.design-color-picker .ant-color-picker-color-block {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.abjust-colors.ant-color-picker-trigger {\n  width: 100% !important;\n  min-width: 120px !important;\n  height: 120px !important;\n}\n\n.abjust-colors:not(.ant-popover) .ant-color-picker-color-block {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.rct-tree-root {\n  width: calc(50%);\n  margin-right: 10px;\n}\n\n.rct-tree-item-button:hover {\n  background: none !important;\n}\n\n.rct-tree-item-li {\n  box-sizing: content-box !important;\n  background-color: rgb(245 245 244 / var(--tw-bg-opacity));\n}\n\n.rct-tree-item-button {\n  margin: 7px 0px !important;\n  cursor: move !important;\n}\n\nbutton.ant-btn-primary:hover {\n  background-color: #5db5e8 !important;\n  color: #fff !important;\n}\n\n\n/* ANIMATIONS */\n\n.slide-top {\n  -webkit-animation: slide-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) normal;\n  animation: slide-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) normal;\n}\n\n/* ----------------------------------------------\n * Generated by Animista on 2023-10-20 14:32:53\n * Licensed under FreeBSD License.\n * See http://animista.net/license for more info. \n * w: http://animista.net, t: @cssanimista\n * ---------------------------------------------- */\n\n/**\n * ----------------------------------------\n * animation slide-top\n * ----------------------------------------\n */\n@-webkit-keyframes slide-top {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-30px);\n    transform: translateY(-30px);\n  }\n\n  100% {\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1;\n  }\n}\n\n@keyframes slide-top {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-30px);\n    transform: translateY(-30px);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.keywords-tags>.ant-select-selector {\n  border: none !important;\n}\n\n.page-tree-menu>li.ant-menu-item {\n  padding: 0px !important;\n}\n\n.page-tree-menu {\n  border-inline-end: none !important;\n}\n\n/**\n* Tree styles\n*/\n\n.nodeWrapper {\n  border-radius: 5px;\n  cursor: pointer;\n  white-space: nowrap;\n  position: relative;\n  z-index: 3;\n}\n\n.nodeWrapper .expandIconWrapper {\n  align-items: center;\n  font-size: 0;\n  cursor: pointer;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  width: 24px;\n  transform: rotate(0deg);\n}\n\n.nodeWrapper .expandIconWrapper.isOpen {\n  transform: rotate(180deg);\n}\n\n.nodeWrapper .expandIconWrapper.isOpen svg path {\n  fill: #4f5272;\n}\n\n.nodeWrapper .labelGridItem {\n  padding-inline-start: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pipeY {\n  position: absolute;\n  border-left: 2px solid #e7e7e7;\n  left: -7px;\n  /*top: 5px;*/\n  top: -13px;\n}\n\n.pipeX {\n  position: absolute;\n  left: -7px;\n  top: 15px;\n  height: 2px;\n  background-color: #e7e7e7;\n  z-index: -1;\n}\n\n.wrapper {\n  font-family: sans-serif;\n}\n\n.treeRoot {\n  list-style-type: none;\n  padding-inline-start: 0px;\n  padding: 0px 0px;\n  position: relative;\n}\n\n.treeRoot ul {\n  list-style-type: none;\n  padding-inline-start: 0px;\n  position: relative;\n  padding-bottom: 5px;\n}\n\n.treeRoot>li:after {\n  display: none;\n}\n\n.wrapper .draggingSource {\n  opacity: 0.3;\n}\n\n.wrapper .placeholder {\n  position: relative;\n}\n\n.wrapper>ul>li>.nodeWrapper>div.pipeY {\n  display: none;\n}\n\n[data-tree] li[role='listitem'] {\n  margin: 6px 0px;\n}\n\n[data-tree]>ul[role='list']>li>div>[data-pipe-y] {\n  top: 5px !important;\n  display: none !important;\n}\n\n.wrapper li:has(> .dropTarget) {\n  outline: 3px solid #e8f0fe;\n  border-radius: 4px;\n}\n\n.ant-modal-content {\n  border-radius: 16px !important;\n  padding: 24px !important;\n}\n\n.phone{\n  transition: all 0.3s ease;\n}\n\n.phone:hover{\n  border-bottom: transparent !important;\n}\n\ninput,\nselect,\ntextarea,\n.ant-input,\n.ant-select-selector,\n.ant-picker,\n.ant-input-affix-wrapper {\n  font-size: 16px !important;\n  line-height: 24px !important;\n  border-radius: 16px !important;\n  height: auto !important;\n  padding: 8px 16px !important;\n}\n\n.ant-select-selection-search-input {\n  padding-left: 8px !important;\n  padding: 7px 8px !important;\n  height: 100% !important;\n}\n\n.ant-select-selection-search {\n  /* width: 100% !important; */\n}\n\n.ant-select-selection-search-input {\n  width: 100% !important;\n  padding-left: 4px !important;\n}\n\n.ant-select-selection-placeholder {\n  padding-left: 8px !important;\n}\n\ninput::placeholder,\ntextarea::placeholder,\n.ant-input::placeholder,\n.ant-select-selection-placeholder {\n  color: #00000040 !important;\n  opacity: 1 !important;\n}\n\nbutton:not(.slider-button) {\n  height: auto;\n}\n\n/* .ant-btn-icon-only{\n  padding: 10px 20px !important;\n} */\n\nbutton.disabled span {\n  color: rgba(0, 0, 0, 0.25) !important;\n}\n\nbutton.disabled svg {\n  opacity: 0.4;\n  background: #0000000A;\n}\n\n.ant-btn {\n  white-space: normal !important;\n}\n\n.custom-checkbox.ant-btn {\n  padding-top: 12px !important;\n  padding-right: 24px !important;\n  padding-bottom: 12px !important;\n  padding-left: 20px !important;\n}\n\n.search-images-input input {\n  border-radius: none !important;\n  border-end-end-radius: 0 !important;\n  border-start-end-radius: 0 !important;\n\n  border-start-start-radius: 0 !important;\n  border-end-start-radius: 0 !important;\n  height: 40px !important;\n\n}\n\n.search-images-input button {\n  height: 40px !important;\n}\n\n.search-activity-input {\n  height: auto !important;\n}\n\n.ant-select-selection-placeholder {\n  text-align: left !important;\n}\n\n.ant-select-selector {\n  padding: 5px !important;\n}\n\n.ant-select-arrow {\n  margin-top: -3px !important;\n}\n\n.ant-input-outlined .ant-input {\n  padding: 0 !important;\n  padding-left: 10px !important;\n}\n\n.company-data-form label:not(.ant-radio-wrapper) {\n  font-weight: 700 !important;\n}\n\n.company-data-form label {\n  text-align: left !important;\n}\n\n.company-data-social-form .ant-select-selector {\n  height: 100% !important;\n}\n\n.company-data-social-form .ant-select-arrow {\n  margin-top: -7px !important;\n}\n\n.company-data-form label:before {\n  display: none !important;\n}\n\n.company-data-form .ant-select-selector {\n  padding: 4px !important;\n}\n\n.ant-input-prefix {\n  opacity: 0.45;\n}\n\n.ant-select-selection-item {\n  padding-left: 12px !important;\n  text-align: left !important;\n}\n\n.ant-color-picker-input-container .ant-select-selection-item {\n  font-size: 12px !important;\n}\n\n.ant-color-picker .ant-input,\n.ant-color-picker input {\n  padding: 4px 11px !important;\n  font-size: 12px !important;\n}\n\n.ant-color-picker-input-container {\n  align-items: center !important;\n}\n\n.ant-color-picker-hex-input .ant-input-sm {\n  padding: 0 !important;\n\n}\n\n.ant-color-picker-input-container .ant-input-number-input {\n  padding: 4px 7px !important;\n}\n\n.ant-input-number-input {\n  padding: 4px !important;\n}\n\n:where(.css-dev-only-do-not-override-1c9uand).ant-color-picker .ant-color-picker-inner .ant-color-picker-input-container .ant-color-picker-format-select.ant-select {\n  height: 100% !important;\n}\n\n.ant-color-picker-input-container .ant-input-affix-wrapper {\n  padding: 4px !important;\n  border-radius: 5px !important;\n}\n\n.ant-form-item-explain-error {\n  text-align: left !important;\n}\n\n.social-media-item .ant-select-selection-item {\n  font-size: 16px !important;\n}\n\n.social-media-item .ant-select {\n  height: 40px !important;\n}\n\n.pulse {\n  animation: pulse-animation 2s infinite;\n}\n\n@keyframes pulse-animation {\n  0% {\n    box-shadow: 0 0 0 0 rgba(52, 152, 219, 0.8);\n  }\n\n  100% {\n    box-shadow: 0 0 0 20px rgba(52, 152, 219, 0);\n  }\n}\n\n.mt-4 .ant-upload {\n  width: 100%;\n}\n\n.sitemap-keywords>.ant-select-selector {\n  border: none !important;\n  background-color: transparent !important;\n  border-radius: 12px !important;\n}\n\n.sitemap-keywords .ant-select {\n  border-radius: 12px !important;\n}\n\n.sitemap-keywords .ant-select-selector {\n  \n}\n\n\n#customKeywords {\n  width: auto !important;\n  appearance: none !important;\n  border-radius: none !important;\n  min-width: auto !important;\n}\n\n.preview-editor-shell {\n  --preview-header-h: 48px;\n  --preview-mobile-nav-h: 67px;\n  --preview-footer-h: 72px;\n  --preview-cta-h: 72px;\n  --preview-mobile-chrome-top: calc(var(--preview-header-h) + var(--preview-mobile-nav-h));\n  --preview-mobile-chrome-bottom: calc(var(--preview-footer-h) + var(--preview-cta-h) + 8px);\n  --preview-mobile-cta-bottom: var(--preview-footer-h);\n  --preview-sitemap-drawer-top: 72px;\n  --preview-sitemap-drawer-height: calc(100vh - 162px);\n}\n\n@media (min-width: 768px) {\n  .preview-editor-shell {\n    --preview-mobile-chrome-top: 0px;\n    --preview-mobile-chrome-bottom: 0px;\n  }\n}\n\n.preview-editor-shell .preview-iframe {\n  height: calc(100vh - var(--preview-mobile-chrome-top) - var(--preview-mobile-chrome-bottom));\n}\n\n@media (min-width: 768px) {\n  .preview-editor-shell .preview-iframe {\n    height: calc(100vh - 300px);\n  }\n}\n\n.reset-wizard-preview {\n  position: fixed;\n  left: 0;\n  right: 0;\n  z-index: 999;\n  margin-top: 0;\n}\n\n@media (max-width: 767px) {\n  .preview-editor-active,\n  .preview-editor-shell {\n    --preview-reset-form-bottom: calc(\n      var(--preview-mobile-cta-bottom) + var(--preview-cta-h) + 8px\n    );\n  }\n\n  .reset-wizard-preview {\n    bottom: var(--preview-reset-form-bottom);\n    display: flex;\n    justify-content: flex-start;\n    padding: 4px 12px;\n    background: #fff;\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n  }\n}\n\n@media (min-width: 768px) {\n  .reset-wizard-preview {\n    bottom: 242px;\n    display: flex;\n    justify-content: center;\n  }\n}\n@media (max-width: 768px) {\n  .reset-wizard-preview {\n    bottom: 160px;\n    display: flex;\n    justify-content: center;\n    button {\n      padding: 4px 0 !important;\n    }\n  }\n}\n@media (max-width: 639px) {\n  .reset-wizard-preview {\n    bottom: 150px;\n    display: flex;\n    justify-content: center;\n    button {\n      padding: 4px 0 !important;\n    }\n  }\n}\n/* @media (max-width: 639px) {\n  .reset-wizard-preview {\n    bottom: 188px;\n    display: flex;\n    justify-content: center;\n  }\n} */\n\n@media (max-width: 767px) {\n  .preview-editor-shell {\n    --preview-header-h: 0px;\n    --preview-mobile-chrome-top: var(--preview-mobile-nav-h);\n    --preview-sitemap-drawer-top: var(--preview-mobile-chrome-top);\n    --preview-sitemap-drawer-height: calc(100vh - var(--preview-mobile-chrome-top) - var(--preview-footer-h));\n  }\n\n  .preview-editor-active {\n    --preview-footer-h: 72px;\n    --preview-cta-h: 72px;\n    --preview-mobile-cta-bottom: var(--preview-footer-h);\n  }\n\n  .preview-editor-shell .preview-drawer-panel {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: var(--preview-mobile-chrome-top);\n    bottom: var(--preview-mobile-chrome-bottom);\n    z-index: 105;\n    width: 100% !important;\n    height: auto;\n    overflow-y: auto;\n    background: #fff;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    padding-bottom: 100px;\n  }\n}\n\n@media (min-width: 768px) {\n  .preview-editor-shell .preview-drawer-panel {\n    display: flex;\n    flex-direction: column;\n    width: 350px;\n    height: 100%;\n    flex-shrink: 0;\n    overflow-y: auto;\n    background: #fff;\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.04);\n    z-index: 9;\n    padding-bottom: 100px;\n  }\n}\n\n.preview-no-scroll {\n  overflow-y: hidden !important;\n}\n\n.whitespace-nowrap{\n  white-space: nowrap !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
